export const mapDataForPost = (data) => {
  const result = Object.keys(data).reduce((acc, key) => {
    if (key !== 'queries' && key !== 'languages') {
      return { ...acc, [key]: data[key] };
    } else {
      const isMultimarket = !!data.queries[0]?.languageId;
      if (!isMultimarket) return { ...acc, queries: data.queries };
      const queries = data.queries.map((query) => query.terms).flat();
      const languages = data.queries
        .map((query) =>
          query.terms.map((term) => ({
            query: term,
            language:
              query.languageId === '0'
                ? null
                : {
                    id: query.languageId,
                  },
          }))
        )
        .flat();
      return { ...acc, queries, languages };
    }
  }, {});
  return result;
};

export const parseDataForList = (data) => ({
  entities: data.map((entity) =>
    entity.use_multimarket
      ? {
          ...entity,
          languages: [
            ...new Set(
              entity.languages
                .filter((language) => language.language)
                .map((language) => language.language.id)
            ),
          ],
        }
      : entity
  ),
});

type Data = {
  queries: string[];
  languages: {
    query: string;
    language: { id: string } | null;
  }[];
  use_multimarket: boolean;
};

type Item = {
  languageId: string;
  terms: string[];
};

type Result = {
  languages: Item[];
};

export const parseDataForDisplay = (data: Data) => {
  if (!data.use_multimarket) return { entity: data };
  const queries = data.queries.reduce((acc: Item[], query) => {
    const languageQueryObj = data.languages.find(
      (language) => language.query === query
    );
    const currentLanguageId = languageQueryObj?.language?.id || '0';
    const isAlreadyPresent = !!acc.find(
      (item: Item) => item.languageId === currentLanguageId
    );
    if (!isAlreadyPresent) {
      return [
        ...acc,
        { languageId: currentLanguageId, terms: [languageQueryObj?.query] },
      ];
    } else {
      const alreadyPresentLanguage = acc.find(
        (item: Item) => item.languageId === currentLanguageId
      );
      if (!alreadyPresentLanguage) return acc;

      return [
        ...acc.filter((item) => item.languageId !== currentLanguageId),
        {
          languageId: currentLanguageId,
          terms: [...alreadyPresentLanguage?.terms, languageQueryObj?.query],
        },
      ];
    }
  }, []);

  return {
    entity: {
      ...data,
      queries,
    },
  };
};
